<template>
  <v-container fluid>
    <h3>Reporte de caja</h3>

    <v-row dense>
      <v-col cols="12">
        <v-row align="center">
          <v-col class="flex-shrink-1 flex-grow-0">
            <b>Desde:</b>
          </v-col>
          <v-col cols="12" md="3">
            <date-time-input  v-model="dateFrom" @input="fetch" :clearable="false"></date-time-input>
          </v-col>
          <v-col class="flex-shrink-1 flex-grow-0">
            <b>Hasta:</b>
          </v-col>
          <v-col cols="12" md="3">

            <date-time-input  v-model="dateTo" @input="fetch" :clearable="false"></date-time-input>
          </v-col>

          <v-col>
            <span><b>Ordenes</b>: {{ getOrdersQuantity }} (${{ getOrdersAmount.toFixed(0) }})</span>
          </v-col>
          <v-col>
            <v-btn
                v-if="exportFile"
                :href="exportFile"
                class="green darken-2 white--text float-right"
                ref="exportBtn"
            >
              <v-icon>download</v-icon>
            </v-btn>

            <v-btn
                v-else
                @click="cashAuditExport"
                :loading="exportLoading"
                class="blue darken-2 white--text float-right"

            >
              Exportar
            </v-btn>

          </v-col>
        </v-row>


      </v-col>

      <v-col cols="12">
        <loading v-if="loading"></loading>


        <v-card v-if="!loading && orders.length > 0">
          <v-row>
            <v-col cols="12" sm="4">
              <v-tabs vertical v-model="tabs">
                <v-tab v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                  <span>{{ deliveryUser ? deliveryUser : 'Mostrador' }}</span>
                  <v-spacer></v-spacer>
                  <span>{{ getOrdersQuantityByUser(deliveryUser) }} (${{
                      getOrdersAmountByUser(deliveryUser).toFixed(0)
                    }})</span>
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="12" sm="8">
              <v-tabs-items v-model="tabs">
                <v-tab-item v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                  <order-report-detail
                      :delivery-user="deliveryUser"
                      :report="getReportByUser(deliveryUser)"
                      :orders="getOrdersByUser(deliveryUser)"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>

        </v-card>

        <v-alert v-else type="info">
          Sin datos para la fecha seleccionada
        </v-alert>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { DateTimeInput, Dayjs} from "@dracul/dayjs-frontend"
import {Loading} from "@dracul/common-frontend";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import OrderReportDetail from "@/modules/delivery/components/OrderReportDetail";
import CashAuditProvider from "@/modules/delivery/providers/CashAuditProvider";

export default {
  name: "OrderReportPage",
  components: {OrderReportDetail, DateTimeInput, Loading},
  data() {
    return {
      loading: false,
      date: Dayjs().startOf('day'),
      dateFrom: Dayjs().startOf('day'),
      dateTo: Dayjs().endOf('day'),
      orders: [],
      tabs: null,
      exportLoading: false,
      exportFile: null,
    }
  },
  created() {
    this.fetch()
  },
  computed: {
    getDeliveryUsers() {
      return this.orders.reduce((a, v) => {
        if (v.deliveryUser && !a.includes(v.deliveryUser.username))
          a.push(v.deliveryUser.username)
        return a
      }, [''])
    },
    getOrdersByUser() {
      return deliveryUser => {
        return this.orders.filter(o => (!deliveryUser && !o.deliveryUser) || (o.deliveryUser && o.deliveryUser.username === deliveryUser))
      }
    },
    getReportByUser() {
      return deliveryUser => {

        let reports = [] //{method, quantity, amount}
        this.getOrdersByUser(deliveryUser).forEach(order => {
          let report = reports.find(r => r.method === order.payment.method)
          if (report) {
            report.quantity++
            report.itemsAmount += order.itemsAmount
            report.promoAmount += order.promoAmount
            report.totalDiscount += order.totalDiscount
            report.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
            report.totalAmount += order.totalAmount
          } else {
            reports.push({
              method: order.payment.method,
              user: deliveryUser,
              quantity: 1,
              itemsAmount: order.itemsAmount,
              promoAmount: order.promoAmount,
              totalDiscount:  order.totalDiscount,
              deliveryCost: order.deliveryFree ? 0 : order.delivery.cost,
              totalAmount: order.totalAmount
            })
          }

        })

        return reports
      }
    },
    getOrdersQuantity() {
      return this.orders.length
    },
    getOrdersAmount() {
      return this.orders.reduce((a, o) => a + o.totalAmount, 0)
    },
    getOrdersQuantityByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).length
    },
    getOrdersAmountByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).reduce((a, o) => a + o.totalAmount, 0)
    }

  },
  methods: {
    fetch() {
      this.loading = true
      this.exportFile = null
      OrderProvider.orderFetchByStateBetweenDates(['READY','ON_THE_WAY','DELIVERED'], this.dateFrom, this.dateTo)
          .then(r => {
            this.orders = r.data.orderFetchByStateBetweenDates
          })
          .finally(() => this.loading = false)
    },
    cashAuditExport() {
      this.exportLoading = true
      CashAuditProvider.cashAuditExport(this.date)
          .then(r => {
            this.exportFile = r.data.cashAuditExport
          })
          .finally(() => this.exportLoading = false)
    }
  }
}
</script>

